import { useMemo } from 'react'
import { aUser, useAtom } from '~/atoms'
import { Avatar, AvatarFallback, Button } from '~/components/ui'

export default function UserAvatar() {
  const [user] = useAtom(aUser)

  const fallback = useMemo(() => {
    return user === null
      ? null
      : [user!.first_name.slice(0, 1), user!.last_name.slice(0, 1)].join('')
  }, [user])

  if (user === null) {
    return null
  }

  return (
    <Button asChild variant="map" size="map">
      <a href="https://portal.resimplifi.com">
        <Avatar className="">
          {fallback && (
            <AvatarFallback className="rounded-none bg-transparent text-base">
              {fallback}
            </AvatarFallback>
          )}
        </Avatar>
      </a>
    </Button>
  )
}
